"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[795],{

/***/ 13032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31955);


var iskibris = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "https://api.iskibris.com",
    headers: {
        Accept: "application/json"
    }
});
iskibris.interceptors.request.use(function(request) {
    var authToken = js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("auth_token");
    var companyToken = js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("CompanyToken");
    if (authToken) {
        request.headers["Authorization"] = "Bearer ".concat(authToken);
    }
    if (companyToken) {
        request.headers["CompanyToken"] = "".concat(companyToken);
    }
    return request;
});
iskibris.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    var ref;
    if (((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 401) {
        var _NEXT_PUBLIC_APP_DOMAIN;
        // localStorage.removeItem("auth_token")
        // localStorage.removeItem("refresh_token")
        // localStorage.removeItem("current_company_id")
        // localStorage.removeItem("CompanyToken")
        js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].remove */ .Z.remove("auth_token", {
            domain: (_NEXT_PUBLIC_APP_DOMAIN = ".iskibris.com") !== null && _NEXT_PUBLIC_APP_DOMAIN !== void 0 ? _NEXT_PUBLIC_APP_DOMAIN : ".iskibris.com"
        });
        js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].remove */ .Z.remove("CompanyToken");
    // store.dispatch(action(actionTypes.UNAUTHENTICATE))
    }
    return Promise.reject(error);
});
/* harmony default export */ __webpack_exports__["Z"] = (iskibris);


/***/ }),

/***/ 49794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Greetings; }
/* harmony export */ });
/* unused harmony export greetingMessage */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15861);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84679);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82651);

/*
 * Copyright (C) 2020 Is Kibris - All Rights Reserved
 * Is Kibris Hiring - https://hiring.iskbris.com
 * Innovia - https://www.innoviadigital.biz
 *
 * Authors:
 * Diligence Vagere - diligence@innovia.biz
 *
 * Description:
 * Component which contains the greeting text
 */ 



var greeting;
var getGreetingMessage = function() {
    var timeOfTheDay = new Date();
    var morningEnd = new Date();
    var morningcheck = morningEnd.getHours();
    morningEnd.setHours(12, 0, 0);
    var afternoonEnd = new Date();
    afternoonEnd.setHours(17, 0, 0);
    //ddd
    if (timeOfTheDay <= morningEnd) {
        greeting = "G\xfcnaydın";
        return 0;
    } else if (timeOfTheDay <= afternoonEnd) {
        greeting = "T\xfcnaydın";
        return 1;
    } else {
        greeting = "İyi akşamlar";
        return 2;
    }
};
var greetingMessage = getGreetingMessage();
function Greetings() {
    var classes = (0,_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), day = ref[0], setday = ref[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            display: "flex",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            variant: "h4",
            className: classes.greetingMessage,
            children: greeting
        })
    }));
};


/***/ }),

/***/ 84679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41120);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
/* harmony default export */ __webpack_exports__["Z"] = ((0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
    var _obj, _obj1, _obj2;
    return {
        root: _defineProperty({
            padding: theme.spacing(4, 4),
            maxWidth: "500px",
            width: "100%"
        }, theme.breakpoints.down("xs"), {
            padding: theme.spacing(2, 2),
            maxWidth: "80%",
            marginLeft: "10%"
        }),
        greetingMessage: {
            marginBottom: "20px"
        },
        googleLoginButton: {
            width: "100%",
            height: "50px",
            textTransform: "none",
            boxShadow: theme.shadows[5],
            textAlign: "center",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            fontFamily: "Helvetica, sans- serif",
            fontWeight: 700,
            fontSize: "16px",
            cursor: "pointer"
        },
        facebookLoginButton: {
            cursor: "pointer",
            width: "100%",
            height: "50px",
            textTransform: "none",
            backgroundColor: "#3C5A99",
            color: "white",
            boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)",
            textAlign: "center",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            fontFamily: "Helvetica, sans- serif",
            fontWeight: 700,
            fontSize: "16px"
        },
        gondersubmit: {
            margin: theme.spacing(3, 0, 2),
            backgroundColor: "#e61e8f",
            marginTop: "4%",
            "&:hover": {
                color: "white",
                background: "#e61e8f"
            }
        },
        submit: {
            margin: theme.spacing(3, 0, 2)
        },
        loginError: {
            backgroundColor: "#EB4F63",
            color: "white",
            width: "95%",
            maxWidth: "600px",
            marginBottom: "10px",
            borderRadius: "3px",
            align: "center",
            padding: "15px"
        },
        form: {
            width: "100%",
            marginLeft: "45%"
        },
        forgetpassword: {
            marginTop: "100px"
        },
        extraActionButtonGrid: (_obj = {}, _defineProperty(_obj, theme.breakpoints.up("sm"), {
            marginTop: "5px"
        }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
            justifyContent: "center",
            display: "flex",
            marginTop: "15px"
        }), _obj),
        customDividerContainer: {
            position: "relative",
            marginTop: 10,
            textAlign: "center"
        },
        customDividerLine: {
            width: "100%",
            backgroundColor: "#cecece",
            position: "absolute",
            left: 0,
            top: "50%"
        },
        paperTypography: {
            marginInlineStart: "10%",
            marginTop: "4px"
        },
        customDividerContent: {
            position: "relative",
            display: "inline-block",
            margin: "10px 0",
            padding: "0 5px",
            background: "#F2F2F2",
            borderRadius: "4px",
            borderLeft: "1px solid #cecece",
            borderRight: "1px solid #cecece"
        },
        checkouttextfield: _defineProperty({
            marginTop: "30px",
            minWidth: "90%",
            textAlign: "left"
        }, theme.breakpoints.down("xs"), {
            width: "76%",
            textAlign: "left"
        }),
        checkouttextfields: {
            width: "230px",
            textAlign: "left"
        },
        iconbutton: {
            "&:hover": {
                cursor: "text"
            }
        },
        typocolor: {
            color: "#b41870"
        },
        checkoutbuttons: (_obj1 = {
            marginTop: "30px",
            minWidth: "90%",
            textTransform: "none",
            color: "#fff",
            backgroundColor: "#b41870"
        }, _defineProperty(_obj1, theme.breakpoints.down("xs"), {
            width: "76%"
        }), _defineProperty(_obj1, " &:hover", {
            backgroundColor: "#ea148d"
        }), _obj1),
        checkoutbutton: (_obj2 = {
            marginTop: "30px",
            minWidth: "90%",
            textTransform: "none",
            color: "#fff",
            backgroundColor: "#b41870"
        }, _defineProperty(_obj2, theme.breakpoints.down("xs"), {
            width: "77%"
        }), _defineProperty(_obj2, " &:hover", {
            backgroundColor: "#ea148d"
        }), _obj2)
    };
}));


/***/ }),

/***/ 66278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);


function Footer() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
        className: "section section--gray",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "wrapper",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row__medium-3 footer__address",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/iskibris_footer.png",
                                    alt: "İş Kıbrıs Logo",
                                    width: "160px",
                                    height: "48px"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "heading heading--small",
                                children: [
                                    "Şehit Cumhur Y\xfczl\xfc Sokak ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    " Vega Apartmanı Daire: 12 ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    " Ortak\xf6y, Lefkoşa"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "https://goo.gl/maps/UYzvoM1DtajV7mNK8",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Konumumuz icin tıklayın"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "mailto://info@iskibris.com",
                                children: "info@iskibris.com"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: "0542 857 0360"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row__medium-3 footer__section",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "headline headline--small",
                                children: "Site Kullanımı"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: "footer__nav",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: "footer__item",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                            href: "/terms-conditions",
                                            children: "Şartlar & Koşullar"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: "footer__item",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                            href: "/privacy-policy",
                                            children: "Gizlilik Politikamız"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row__medium-3 footer__section",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "headline headline--small",
                                children: "Firma İşlemleri"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: "footer__nav",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: "footer__item",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                            href: "#",
                                            children: "İş İlanı Yayınla"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: "footer__item",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                            href: "#",
                                            children: "Firma \xdcyeliği"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: "footer__item",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                            href: "https://hiring.iskibris.com",
                                            children: "Firma Girişi"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row__medium-3 footer__section",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://play.google.com/store/apps/details?id=com.innoviadigital.iskibris&hl=en_US",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/google_play.jpeg",
                                        alt: "Is Kibris Google Play"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://apps.apple.com/us/app/i-%C5%9F-k%C4%B1br%C4%B1s/id1266248384",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        cursor: "pointer",
                                        marginTop: "0.2rem"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/app_store.jpeg",
                                        alt: "Is Kibris App Store"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    }));
};


/***/ }),

/***/ 77297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./src/api/iskibris/client.js
var client = __webpack_require__(13032);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 7 modules
var Menu = __webpack_require__(63375);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 3 modules
var MenuItem = __webpack_require__(23599);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./src/components/UserMenu.js







function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var UserMenu = function(param) {
    var user = param.user, onLogout = param.onLogout;
    var ref = _slicedToArray(react.useState(null), 2), anchorElUser = ref[0], setAnchorElUser = ref[1];
    var handleOpenUserMenu = function(event) {
        setAnchorElUser(event.currentTarget);
    };
    var handleCloseUserMenu = function() {
        setAnchorElUser(null);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                className: "primary-nav--pull-right",
                onClick: handleOpenUserMenu,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        alt: "Remy Sharp",
                        src: user === null || user === void 0 ? void 0 : user.avatar_url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body1",
                        sx: {
                            color: "white",
                            paddingLeft: "10px"
                        },
                        children: user === null || user === void 0 ? void 0 : user.full_name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                sx: {
                    mt: "60px"
                },
                id: "menu-appbar",
                anchorEl: anchorElUser,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                keepMounted: true,
                transformOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                open: Boolean(anchorElUser),
                onClose: handleCloseUserMenu,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                    onClick: onLogout,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        textAlign: "center",
                        children: " \xc7ıkış Yap"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var components_UserMenu = (UserMenu);

// EXTERNAL MODULE: ./src/context/AppStateContext.js
var AppStateContext = __webpack_require__(7095);
// EXTERNAL MODULE: ./src/context/DispatchContext.js
var DispatchContext = __webpack_require__(83594);
// EXTERNAL MODULE: ./src/components/LoginModal/LoginModal.js + 7 modules
var LoginModal = __webpack_require__(53706);
;// CONCATENATED MODULE: ./src/components/Header.js












function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Alert = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function Alert(props, ref) {
    return(/*#__PURE__*/ _jsx(MuiAlert, _objectSpread({
        elevation: 6,
        ref: ref,
        variant: "filled"
    }, props)));
})));
function Header() {
    var ref = (0,react.useState)(false), menuOpen = ref[0], setMenuOpen = ref[1];
    var AuthState = (0,react.useContext)(AppStateContext/* default */.Z).AuthState;
    var AuthDispatcher = (0,react.useContext)(DispatchContext/* default */.Z).AuthDispatcher;
    var ref1 = (0,react.useState)(true), open = ref1[0], setOpen = ref1[1];
    var handleClick = function() {
        setOpen(true);
    };
    var handleClose = function(event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };
    var handleLogout = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var _NEXT_PUBLIC_APP_DOMAIN;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client/* default.post */.Z.post("/api/logout").then(function(response) {});
                    case 2:
                        localStorage.removeItem("auth_token");
                        localStorage.removeItem("refresh_token");
                        localStorage.removeItem("current_company_id");
                        localStorage.removeItem("CompanyToken");
                        _ctx.next = 8;
                        return js_cookie/* default.remove */.Z.remove("CompanyToken");
                    case 8:
                        ;
                        _ctx.next = 11;
                        return js_cookie/* default.remove */.Z.remove("auth_token", {
                            domain: (_NEXT_PUBLIC_APP_DOMAIN = ".iskibris.com") !== null && _NEXT_PUBLIC_APP_DOMAIN !== void 0 ? _NEXT_PUBLIC_APP_DOMAIN : ".iskibris.com"
                        });
                    case 11:
                        AuthDispatcher({
                            type: "logout"
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    function getIskibrisProfile() {
        return _getIskibrisProfile.apply(this, arguments);
    }
    function _getIskibrisProfile() {
        _getIskibrisProfile = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client/* default.get */.Z.get("/api/user/profile").then(function(response) {
                            var user = response.data;
                            var userval = user.is_employer;
                            // AuthDispatcher({ type: "addUser", payload: user })
                            // if (userval) {
                            AuthDispatcher({
                                type: "addUser",
                                payload: user
                            });
                            return 1;
                        // } else {
                        //   AuthDispatcher({ type: "logout" })
                        //   return 0
                        // }
                        }).catch(function(error) {});
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _getIskibrisProfile.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        // console.log(">>> Header useEffect: attempt fetchProfile: isLoggedIn", AuthState.isLoggedIn)
        if (AuthState.isLoggedIn && !AuthState.user) {
            // console.log(">>> Header useEffect: fetchProfile on isLoggedIn true and no user: ", AuthState.isLoggedIn)
            getIskibrisProfile();
        }
    }, [
        AuthState.isLoggedIn,
        AuthState.user
    ]);
    var handleSuccess = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        AuthDispatcher({
                            type: "login"
                        });
                        _ctx.next = 3;
                        return getIskibrisProfile();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSuccess() {
            return _ref.apply(this, arguments);
        };
    }();
    var RenderMobileMenu = function() {
        if (!menuOpen) return null;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "overlay",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "overlay__header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "overlay__close",
                        onClick: function(e) {
                            return setMenuOpen(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                clipRule: "evenodd"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "overlay__inner",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "header__mobile-menu",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "header__mobile-nav",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/",
                                    onClick: function(e) {
                                        return setMenuOpen(false);
                                    },
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "header__mobile-nav__item",
                                        onClick: function(e) {
                                            return setMenuOpen(false);
                                        },
                                        children: "Anasayfa"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/#features",
                                    onClick: function(e) {
                                        return setMenuOpen(false);
                                    },
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "header__mobile-nav__item",
                                        onClick: function(e) {
                                            return setMenuOpen(false);
                                        },
                                        children: "\xd6zellikler"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/#pricing",
                                    onClick: function(e) {
                                        return setMenuOpen(false);
                                    },
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "header__mobile-nav__item",
                                        onClick: function(e) {
                                            return setMenuOpen(false);
                                        },
                                        children: "\xdccretlendirme"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/#testimonials",
                                    onClick: function(e) {
                                        return setMenuOpen(false);
                                    },
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "header__mobile-nav__item",
                                        onClick: function(e) {
                                            return setMenuOpen(false);
                                        },
                                        children: "Referanslarımız"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/blog",
                                    onClick: function(e) {
                                        return setMenuOpen(false);
                                    },
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "header__mobile-nav__item",
                                        onClick: function(e) {
                                            return setMenuOpen(false);
                                        },
                                        children: "Blog"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/contact",
                                    onClick: function(e) {
                                        return setMenuOpen(false);
                                    },
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "header__mobile-nav__item",
                                        onClick: function(e) {
                                            return setMenuOpen(false);
                                        },
                                        children: "Bize Ulaşmak İ\xe7in"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/",
                                    onClick: function(e) {
                                        return setMenuOpen(false);
                                    },
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "header__mobile-nav__item",
                                        onClick: function(e) {
                                            return setMenuOpen(false);
                                        },
                                        children: "Destek Portalı"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "https://hiring.iskibris.com",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "header__mobile-nav__item header__mobile-nav__item--alt",
                                        children: "Giriş Yap"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "site-header",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row row--purple row--action header__top--height-reset",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "wrapper header__top",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                            className: "primary-nav primary-nav--pull-right",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "header__nav",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "header__link header__link--hover-lightest",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "/blog",
                                                children: "Blog"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "header__link header__link--hover-lightest",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "/contact",
                                                children: "Bize Ulaşmak İ\xe7in"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "header__link header__link--hover-lightest",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "",
                                                children: "Destek Portalı"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "header__link header__link--hover-lightest",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "https://hiring.iskibris.com",
                                                children: "Giriş Yap"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "header__menu",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function(e) {
                                                return setMenuOpen(true);
                                            },
                                            className: "button header__menu-button",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 20 20",
                                                fill: "currentColor",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
                                                    clipRule: "evenodd"
                                                })
                                            })
                                        }),
                                        RenderMobileMenu()
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row row--dark-blue header__bottom",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-wrapper flex-wrapper__space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/",
                            className: "d-inline-block link",
                            style: {
                                cursor: "pointer"
                            },
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/logo_sticky_header.png",
                                className: "header__logo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                            className: "primary-nav flex-wrapper__right",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "header__nav",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "header__link header__link--hover-lightest",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "/",
                                                children: "Anasayfa"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "header__link header__link--hover-lightest",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "/#features",
                                                children: "\xd6zellikler"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "header__link header__link--hover-lightest",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "/#testimonial",
                                                children: "Referanslar"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "header__link header__link--hover-lightest",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "/#pricing",
                                                children: "\xdccretlendirme"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "header__link header__link--hover-lightest",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "/#testimonials",
                                                children: "Referanslarımız"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: "https://hiring.iskibris.com",
                                                children: "İşe Alım Ekranı"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: AuthState.isLoggedIn ? "primary-nav--pull-right" : "primary-nav--pull-right",
                                    children: AuthState.user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserMenu, {
                                        onLogout: handleLogout,
                                        user: AuthState.user
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModal/* default */.Z, {
                                        onSuccess: handleSuccess,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "text",
                                            style: {
                                                color: "#b41870",
                                                marginLeft: "8%",
                                                fontSize: "18px",
                                                marginTop: "1px",
                                                textTransform: "none"
                                            },
                                            size: "large",
                                            children: "Giriş"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 53706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LoginModal_LoginModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 8 modules
var Modal = __webpack_require__(9688);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./src/api/iskibris/client.js
var client = __webpack_require__(13032);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 28 modules
var TextField = __webpack_require__(88204);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/VisibilityOff.js
var VisibilityOff = __webpack_require__(72450);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Visibility.js
var Visibility = __webpack_require__(22961);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 11 modules
var useTranslation = __webpack_require__(82651);
// EXTERNAL MODULE: ./src/components/Authentication/styles.tsx
var styles = __webpack_require__(84679);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
;// CONCATENATED MODULE: ./src/components/Authentication/AuthError/index.tsx






var AuthError = function(props) {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var classes = (0,styles/* default */.Z)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            variant: "body1",
            className: classes.loginError,
            style: {
                textAlign: "center"
            },
            children: [
                "Kimlik bilgileriniz kayıtlarımızla eşleşmedi.",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    style: {
                        color: "#fff"
                    },
                    href: "/forgetpassword",
                    children: "Parolanızı mı unuttunuz? Sıfırlamak i\xe7in burayı tıklayın."
                })
            ]
        })
    }));
};
/* harmony default export */ var Authentication_AuthError = (AuthError);

// EXTERNAL MODULE: ./src/components/Authentication/Greetings/index.tsx
var Greetings = __webpack_require__(49794);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-google-login/dist/google-login.js
var google_login = __webpack_require__(93645);
var google_login_default = /*#__PURE__*/__webpack_require__.n(google_login);
;// CONCATENATED MODULE: ./src/images/google.png
/* harmony default export */ var google = ({"src":"/_next/static/media/google.8254e149.png","height":2000,"width":2000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAVFBMVEVMaXE0qFNDjfHoPicyqkxBhPLxOCrpQTXtRDY/hvYzqVD+wQMif/9DhPbytwo/i9noQjQsqFbBuB3qQzT5mBQppljqOzlHkP//VDU7rn5evEw5t1r7B2pkAAAAF3RSTlMAqnUhV0YJpuqs5aYIv+qUXJ9XV1d8fGNEMkQAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA/SURBVHicHcZJEoAgDADBYU2C4q6g/v+fVtmnBnaRJQPSVTXA0S9yAIaJ0czSn1qbZ3tO8C3B+pZyzwDRuQgfT2ICK/rTZ8oAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./src/components/Authentication/GoogleAuth/index.tsx


/*
 * Copyright (C) 2020 Is Kibris - All Rights Reserved
 * Is Kibris Hiring - https://hiring.iskbris.com
 * Innovia - https://www.innoviadigital.biz
 *
 * Authors:
 * Diligence Vagere - diligence@innovia.biz
 *
 * Description:
 * Component to allow google signin or signup
 */ 






//import OverlayLoader from "../../OverlayLoader"



function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var _NEXT_PUBLIC_GOOGLE_CLIENT_ID;
var googleClientId = (_NEXT_PUBLIC_GOOGLE_CLIENT_ID = "598313681033-7kjod6030ts2rvr3guv1sjpmvuduen0e.apps.googleusercontent.com") !== null && _NEXT_PUBLIC_GOOGLE_CLIENT_ID !== void 0 ? _NEXT_PUBLIC_GOOGLE_CLIENT_ID : "598313681033-7kjod6030ts2rvr3guv1sjpmvuduen0e.apps.googleusercontent.com";
var GoogleOauth = function(props) {
    var classes = (0,styles/* default */.Z)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = _slicedToArray(react.useState(false), 2), loading = ref[0], setLoading = ref[1];
    var route = (0,router.useRouter)();
    var googleLoginHandler = function(response1) {
        setLoading(true);
        var accessToken = {
            access_token: response1.accessToken
        };
        client/* default.post */.Z.post("/api/login/google", accessToken).then(function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(response) {
                var _NEXT_PUBLIC_APP_DOMAIN, _NEXT_PUBLIC_APP_DOMAIN1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            js_cookie/* default.set */.Z.set("auth_token", response.data.token, {
                                domain: (_NEXT_PUBLIC_APP_DOMAIN = ".iskibris.com") !== null && _NEXT_PUBLIC_APP_DOMAIN !== void 0 ? _NEXT_PUBLIC_APP_DOMAIN : ".iskibris.com",
                                sameSite: "None",
                                secure: true,
                                expires: 364
                            });
                            ;
                            js_cookie/* default.set */.Z.set("is_employer", "true", {
                                domain: (_NEXT_PUBLIC_APP_DOMAIN1 = ".iskibris.com") !== null && _NEXT_PUBLIC_APP_DOMAIN1 !== void 0 ? _NEXT_PUBLIC_APP_DOMAIN1 : ".iskibris.com",
                                sameSite: "None",
                                secure: true,
                                expires: 750
                            });
                            localStorage.setItem("auth_token", response.data["token"]);
                            props.onSuccess();
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }()).catch(function(err) {
            setLoading(false);
            props.onFail();
        });
    };
    //make a props in the main page and pass the function which is the google login to the header page that way it should be fixed
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((google_login_default()), {
            clientId: googleClientId,
            onAutoLoadFinished: function(successLogin) {},
            onSuccess: googleLoginHandler,
            onFailure: function(error) {
                props.onFail();
            },
            render: function(ownProps) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    size: "medium",
                    className: classes.googleLoginButton,
                    onClick: ownProps.onClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            src: google,
                            width: 30,
                            height: 30,
                            className: "_login-form google",
                            alt: "Google"
                        }),
                        "Google ile giriş yap"
                    ]
                });
            }
        })
    }));
};
/* harmony default export */ var GoogleAuth = (GoogleOauth);

// EXTERNAL MODULE: ./node_modules/react-facebook-login/dist/facebook-login-with-button.js
var facebook_login_with_button = __webpack_require__(65749);
var facebook_login_with_button_default = /*#__PURE__*/__webpack_require__.n(facebook_login_with_button);
;// CONCATENATED MODULE: ./src/images/facebook.png
/* harmony default export */ var facebook = ({"src":"/_next/static/media/facebook.0affd40b.png","height":680,"width":680,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEX///////////////////////////////////9MaXH///////+VWGFKAAAAC3RSTlPBhcrW+ytXpmMAAcg/6nwAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA0SURBVHicLclBDgAhDMNAJ6WF3f7/vwjEbWQjgyMEPTpq+qLSQLezxsX6/rdSfcqDgFyhDSjeASmh1MbDAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/components/Authentication/FacebookAuth/index.tsx


/*
 * Copyright (C) 2020 Is Kibris - All Rights Reserved
 * Is Kibris Hiring - https://hiring.iskbris.com
 * Innovia - https://www.innoviadigital.biz
 *
 * Authors:
 * Diligence Vagere - diligence@innovia.biz
 *
 * Description:
 * Component for Facebook login/signup
 */ 








function FacebookAuth_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function FacebookAuth_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function FacebookAuth_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function FacebookAuth_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                FacebookAuth_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                FacebookAuth_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function FacebookAuth_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function FacebookAuth_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function FacebookAuth_slicedToArray(arr, i) {
    return FacebookAuth_arrayWithHoles(arr) || FacebookAuth_iterableToArrayLimit(arr, i) || FacebookAuth_unsupportedIterableToArray(arr, i) || FacebookAuth_nonIterableRest();
}
function FacebookAuth_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return FacebookAuth_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return FacebookAuth_arrayLikeToArray(o, minLen);
}
var _NEXT_PUBLIC_FACEBOOK_APP_ID;
var facebookAppId = (_NEXT_PUBLIC_FACEBOOK_APP_ID = "265061100598605") !== null && _NEXT_PUBLIC_FACEBOOK_APP_ID !== void 0 ? _NEXT_PUBLIC_FACEBOOK_APP_ID : "";
var FacebookAuth = function(props) {
    var classes = (0,styles/* default */.Z)();
    var route = (0,router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = FacebookAuth_slicedToArray(react.useState(false), 2), loading = ref[0], setLoading = ref[1];
    var facebookLoginHandler = function() {
        var _ref1 = FacebookAuth_asyncToGenerator(runtime_default().mark(function _callee1(response1) {
            var accessToken;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        setLoading(true);
                        accessToken = {
                            access_token: response1.accessToken
                        };
                        client/* default.post */.Z.post("/api/login/facebook", accessToken).then(function() {
                            var _ref = FacebookAuth_asyncToGenerator(runtime_default().mark(function _callee(response) {
                                var _NEXT_PUBLIC_APP_DOMAIN, _NEXT_PUBLIC_APP_DOMAIN1;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            ;
                                            js_cookie/* default.set */.Z.set("auth_token", response.data["token"], {
                                                domain: (_NEXT_PUBLIC_APP_DOMAIN = ".iskibris.com") !== null && _NEXT_PUBLIC_APP_DOMAIN !== void 0 ? _NEXT_PUBLIC_APP_DOMAIN : ".iskibris.com",
                                                sameSite: "None",
                                                secure: true,
                                                expires: 364
                                            });
                                            ;
                                            js_cookie/* default.set */.Z.set("is_employer", "true", {
                                                domain: (_NEXT_PUBLIC_APP_DOMAIN1 = ".iskibris.com") !== null && _NEXT_PUBLIC_APP_DOMAIN1 !== void 0 ? _NEXT_PUBLIC_APP_DOMAIN1 : ".iskibris.com",
                                                sameSite: "None",
                                                secure: true,
                                                expires: 750
                                            });
                                            localStorage.setItem("auth_token", response.data["token"]);
                                            setLoading(false);
                                            props.onSuccess();
                                        case 7:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(response) {
                                return _ref.apply(this, arguments);
                            };
                        }()).catch(function(err) {
                            setLoading(false);
                            props.onFail();
                        });
                    case 3:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        }));
        return function facebookLoginHandler(response1) {
            return _ref1.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            justifyContent: "center",
            height: "86px",
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((facebook_login_with_button_default()), {
            appId: facebookAppId,
            fields: "email",
            cssClass: classes.facebookLoginButton,
            buttonStyle: {
                width: "100%",
                height: "50px",
                fontSize: "16px",
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
                borderRadius: "5px",
                boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)",
                // fontWeight: "normal",
                textTransform: "none",
                border: "none"
            },
            textButton: "Facebook ile giriş",
            typeButton: "contained",
            size: "small",
            disableMobileRedirect: true,
            callback: facebookLoginHandler,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                alt: "fb",
                src: facebook,
                width: 30,
                height: 25,
                className: "_login-form facebook"
            })
        })
    }));
};
/* harmony default export */ var Authentication_FacebookAuth = (FacebookAuth);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
;// CONCATENATED MODULE: ./src/components/Authentication/CustomDivider/index.tsx

/*
 * Copyright (C) 2020 Is Kibris - All Rights Reserved
 * Is Kibris Hiring - https://hiring.iskbris.com
 * Innovia - https://www.innoviadigital.com
 *
 * Authors:
 * Diligence Vagere - diligence@innovia.biz
 *
 * Description:
 * Component to divide between social logins and server logins.
 */ 




var CustomDivider = function(props) {
    var classes = (0,styles/* default */.Z)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.customDividerContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                className: classes.customDividerLine
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: classes.customDividerContent,
                children: t("or")
            })
        ]
    }));
};
/* harmony default export */ var Authentication_CustomDivider = (CustomDivider);

;// CONCATENATED MODULE: ./src/components/Authentication/Signin/index.tsx



// import axios from "../../../ api/iskibris/iskibris"
// import axios from "axios"












function Signin_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Signin_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Signin_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Signin_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Signin = function(props) {
    var classes = (0,styles/* default */.Z)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref5 = (0,react.useState)({
        email: "",
        password: ""
    }), values = ref5[0], setValues = ref5[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(false), showPassword = ref2[0], setShowPassword = ref2[1];
    var ref3 = (0,react.useState)(false), wrongCredentials = ref3[0], setWrongCredentials = ref3[1];
    var handleClickShowPassword = function() {
        setShowPassword(!showPassword);
    };
    var handleMouseDownPassword = function(event) {
        event.preventDefault();
    };
    var setValuesHandler = function(name) {
        return function(event) {
            return setValues(_objectSpread({}, values, _defineProperty({}, name, event.target.value)));
        };
    };
    var serverLoginHandler = function() {
        var _ref1 = Signin_asyncToGenerator(runtime_default().mark(function _callee1(event) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        event === null || event === void 0 ? void 0 : event.preventDefault();
                        setLoading(true);
                        setWrongCredentials(false);
                        data = {
                            username: values.email,
                            password: values.password,
                            grant_type: "password",
                            client_id: "7",
                            client_secret: "GQVn52ZzixAP2YaardLbaj1XZP9nHfQvNSbeEEPG"
                        };
                        client/* default.post */.Z.post("/oauth/token", data).then(function() {
                            var _ref = Signin_asyncToGenerator(runtime_default().mark(function _callee(response) {
                                var accessToken, _NEXT_PUBLIC_APP_DOMAIN;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (!(response.status === 200)) {
                                                _ctx.next = 12;
                                                break;
                                            }
                                            accessToken = response.data["access_token"];
                                            _ctx.next = 4;
                                            return js_cookie/* default.set */.Z.set("auth_token", accessToken, {
                                                domain: ".iskibris.com" || 0,
                                                sameSite: "none",
                                                secure: true,
                                                expires: 364
                                            });
                                        case 4:
                                            ;
                                            js_cookie/* default.set */.Z.set("is_employer", "true", {
                                                domain: (_NEXT_PUBLIC_APP_DOMAIN = ".iskibris.com") !== null && _NEXT_PUBLIC_APP_DOMAIN !== void 0 ? _NEXT_PUBLIC_APP_DOMAIN : ".iskibris.com",
                                                sameSite: "None",
                                                secure: true,
                                                expires: 750
                                            });
                                            _ctx.next = 8;
                                            return localStorage.setItem("auth_token", accessToken);
                                        case 8:
                                            _ctx.next = 10;
                                            return localStorage.setItem("refresh_token", response.data["refresh_token"]);
                                        case 10:
                                            setLoading(false);
                                            props.onSuccess();
                                        case 12:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(response) {
                                return _ref.apply(this, arguments);
                            };
                        }()).catch(function(error) {
                            var ref, ref4;
                            if (((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 404 || ((ref4 = error.response) === null || ref4 === void 0 ? void 0 : ref4.status) === 400) {
                                setWrongCredentials(true);
                                setLoading(false);
                            }
                        });
                    case 5:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        }));
        return function serverLoginHandler(event) {
            return _ref1.apply(this, arguments);
        };
    }();
    var loginFailureMessage = null;
    if (wrongCredentials) {
        loginFailureMessage = /*#__PURE__*/ (0,jsx_runtime.jsx)(Authentication_AuthError, {});
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Greetings/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Authentication_FacebookAuth, {
                        mode: "login",
                        onSuccess: props.onFacebookLogin,
                        onFail: function() {}
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAuth, {
                        mode: "login",
                        onSuccess: props.onGoogleLogin,
                        onAuthenticated: function() {
                            props.onGoogleLogin;
                        },
                        onFail: function() {}
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Authentication_CustomDivider, {}),
            loginFailureMessage,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: serverLoginHandler,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            "data-private": "lipsum",
                            variant: "outlined",
                            margin: "dense",
                            required: true,
                            fullWidth: true,
                            size: "small",
                            id: "email",
                            label: "E-posta",
                            name: "email",
                            autoComplete: "email",
                            onChange: setValuesHandler("email")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            "data-private": "lipsum",
                            variant: "outlined",
                            margin: "dense",
                            required: true,
                            fullWidth: true,
                            size: "small",
                            name: "password",
                            label: t("password"),
                            id: "password",
                            autoComplete: "current-password",
                            onChange: setValuesHandler("password"),
                            value: values.password,
                            type: showPassword ? "text" : "password",
                            inputProps: {
                                endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                    position: "end",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        edge: "end",
                                        "aria-label": "toggle password visibility",
                                        onClick: handleClickShowPassword,
                                        onMouseDown: handleMouseDownPassword,
                                        children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {})
                                    })
                                })
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "submit",
                            fullWidth: true,
                            variant: "contained",
                            sx: {
                                backgroundColor: "#e61e8f",
                                marginTop: "4%",
                                "&:hover": {
                                    color: "white",
                                    background: "#e61e8f"
                                }
                            },
                            className: classes.submit,
                            style: {
                                marginTop: "15px",
                                textTransform: "none"
                            },
                            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                size: "30px",
                                style: {
                                    color: "white"
                                }
                            }) : "Giriş"
                        }, Math.random()),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            container: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                className: classes.extraActionButtonGrid,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "text",
                                    style: {
                                        textTransform: "none"
                                    },
                                    href: "/forgot-password",
                                    children: "Şifremi unuttum?"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var Authentication_Signin = (Signin);

;// CONCATENATED MODULE: ./src/components/LoginModal/LoginModal.js









function LoginModal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function LoginModal_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function LoginModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function LoginModal_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                LoginModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                LoginModal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function LoginModal_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function LoginModal_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function LoginModal_slicedToArray(arr, i) {
    return LoginModal_arrayWithHoles(arr) || LoginModal_iterableToArrayLimit(arr, i) || LoginModal_unsupportedIterableToArray(arr, i) || LoginModal_nonIterableRest();
}
function LoginModal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return LoginModal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return LoginModal_arrayLikeToArray(o, minLen);
}
var style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    outline: 0,
    width: 350
};
var LoginModal = function(param) {
    var onSuccess = param.onSuccess, children = param.children;
    var ref = LoginModal_slicedToArray(react.useState(false), 2), open = ref[0], setOpen = ref[1];
    var handleOpenChange = function() {
        setOpen(!open);
    };
    var handleSuccess = function() {
        var _ref = LoginModal_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!onSuccess) {
                            _ctx.next = 3;
                            break;
                        }
                        _ctx.next = 3;
                        return onSuccess();
                    case 3:
                        handleOpenChange();
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSuccess() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClose = function() {
        setOpen(false);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: handleOpenChange,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                open: open,
                onClose: handleClose,
                "aria-labelledby": "modal-modal-title",
                "aria-describedby": "modal-modal-description",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
                    style: style,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "flex-end",
                                position: "relative",
                                top: "10px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Authentication_Signin, {
                            onFacebookLogin: handleSuccess,
                            onGoogleLogin: handleSuccess,
                            onSuccess: handleSuccess
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var LoginModal_LoginModal = (LoginModal);


/***/ })

}]);